// Cell to string
// Returns an excel-like cell name for a cell such as AF581
export function cellToString({ column, row }) {
  return `${columnToChars(column)}${row}`;
}

// Returns an excel-like range name for a cell such as A1:B2
// If total rows and columns provided and a selection takes the entirety of one of them it will return results like "Column C" or "Row 4"
export function isFullColumn({ start, end }, totalRows) {
  return start.row == 1 && end.row == totalRows && start.column == end.column;
}

export function rangeToString({ start, end }, totalRows, totalColumns, t) {
  if (totalColumns && totalRows) {
    const isFullRow = start.column == 1 && end.column == totalColumns && start.row == end.row;

    if (isFullRow) return t('ordering_form.row', { number: start.row });
    if (isFullColumn({ start, end }, totalRows))
      return t('ordering_form.column', { number: columnToChars(start.column) });
  }

  return `${cellToString(start)}:${cellToString(end)}`;
}

export function rangesToStrings(ranges) {
  return ranges.map((range) => rangeToString(range));
}

// "A1" to {column: 1, row: 1}
export function stringToCell(stringCell) {
  let column = [],
    row = [],
    creatingRow = false,
    str;

  for (var i = 0; i < stringCell.length; i++) {
    str = stringCell[i];

    // Separate column from row and return false if invalid
    if (str.match(/[a-zA-Z]/) && !creatingRow) {
      column.push(str.toUpperCase());
    } else if (str.match(/[0-9]/) && column.length) {
      creatingRow = true;
      row.push(str);
    } else {
      return false;
    }
  }

  if (column.length == 0 || row.length == 0) return false;

  return {
    column: charsToColumn(column.join('')),
    row: parseInt(row.join(''))
  };
}

const sortInt = (a, b) => a - b;

// Cell to range
// Creates a range from 2 cells
export function cellsToRange(cell1, cell2) {
  const sortedRows = [cell1.row, cell2.row].sort(sortInt),
    sortedCols = [cell1.column, cell2.column].sort(sortInt),
    start = { row: sortedRows[0], column: sortedCols[0] },
    end = { row: sortedRows[1], column: sortedCols[1] };

  return { start, end };
}

// Column to range
// Converts a column int to the equivalent excel-like string:
// examples 3 == C, 28 == AB
export function columnToChars(column) {
  let rest,
    chars = '',
    remainderColumn = column;

  while (remainderColumn > 0) {
    rest = (remainderColumn - 1) % 26;
    chars = String.fromCharCode(rest + 65) + chars;
    remainderColumn = (remainderColumn - rest - 1) / 26;
  }

  return chars;
}

// Gets the corresponding int of a *single* alphabetic character
// This method is enough to calculate the index of a single character column
function charToColumn(str) {
  let code = str.charCodeAt(0);

  if (code < 65 || code > 90) return false;

  return code - 64;
}

// Uses charToColumn to get the corresponding int of a string of alphabetic characters
function charsToColumn(str) {
  let i,
    column = 0,
    digits = [];

  for (i = str.length - 1; i >= 0; i--) digits.push(charToColumn(str[i]));
  for (i = digits.length - 1; i >= 0; i--) column += digits[i] * Math.pow(26, i);

  return column;
}

export function containedInRange(cell, range) {
  let { start, end } = range,
    { column, row } = cell;

  if (!start || !end) return false;

  // handle complete ranges
  return column >= start.column && column <= end.column && row >= start.row && row <= end.row;
}

export function containedInRanges(cell, ranges) {
  return ranges.some((range) => containedInRange(cell, range));
}

export function isSameCell(cell1, cell2) {
  if (cell1.row != cell2.row) return false;
  if (cell1.column != cell2.column) return false;
  return true;
}
